import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ChevronRight } from 'lucide-react';
import PropertyCard from '../components/PropertyCard';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Referenzen() {
  const [references, setReferences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReferences();
  }, []);

  const fetchReferences = async () => {
    try {
      const response = await axios.get(`${API}/api/references`);
      setReferences(response.data);
    } catch (error) {
      console.error('Error fetching references:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="referenzen-page">
      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-[#0a1120]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm mb-8">
            <Link to="/" className="text-[#c8c6c4] hover:text-[#d1af6a]">Home</Link>
            <ChevronRight className="w-4 h-4 text-[#c8c6c4]" />
            <span className="text-[#d1af6a]">Referenzen</span>
          </nav>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <span className="font-accent text-[#d1af6a] text-xs tracking-[0.2em]">
              REFERENZEN
            </span>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mt-4 mb-6">
              Erfolgreich vermittelt
            </h1>
            <p className="text-[#c8c6c4] text-lg leading-relaxed">
              Immobilien, die ihr neues Zuhause gefunden haben. 
              Ein Auszug aus unseren erfolgreich abgeschlossenen Projekten.
            </p>
          </motion.div>
        </div>
      </section>

      {/* References Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center py-20">
              <div className="spinner" />
            </div>
          ) : references.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-[#c8c6c4] text-lg">
                Noch keine Referenzen vorhanden.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {references.map((reference, index) => (
                <PropertyCard 
                  key={reference.id} 
                  property={reference} 
                  index={index} 
                  isReference={true}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#1a2640]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-2xl sm:text-3xl text-white mb-4">
            Möchten Sie Ihre Immobilie auch erfolgreich vermitteln?
          </h2>
          <p className="text-[#c8c6c4] mb-8">
            Kontaktieren Sie mich für eine unverbindliche Beratung.
          </p>
          <Link to="/kontakt" className="btn-primary">
            Jetzt Kontakt aufnehmen
          </Link>
        </div>
      </section>
    </div>
  );
}
